import styled from 'styled-components';

export const StyledFooter = styled.footer`
  border-top: 1px #eee solid;
  padding: 30px 0;

  p {
    font-weight: 600;
    font-size: ${props => props.theme.fontSizes.small};
    text-transform: lowercase;
    color: #666;
  }
`

export const StyledFooterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media(max-width: ${props => props.theme.breakpoints.mobile}) {
    display: block;
    text-align: center;
  }
`

export const StyledLogo = styled.img`
  height: 32px;
  /* opacity: 0.5;
  filter: grayscale(100%); */
`

export const StyledCreditCards = styled.div`
  display: flex;

  @media(max-width: ${props => props.theme.breakpoints.mobile}) {
    display: block;
    margin: 10px 0 0;
  }
`

export const StyledCreditCardLogo = styled.img`
  /* filter: grayscale(100%); */
  height: 24px;

  & + & {
    margin-left: 5px;
  }
`
